export const flexWrapValues = ['wrap', 'nowrap', 'wrap-reverse'] as const

export const flexJustifyValues = [
  'flex-start',
  'flex-end',
  'start',
  'end',
  'center',
  'left',
  'right',
  'space-between',
  'space-around',
  'space-evenly',
  'stretch',
  'normal',
] as const

export const flexAlignValues = [
  'flex-start',
  'flex-end',
  'start',
  'end',
  'center',
  'baseline',
  'stretch',
  'normal',
] as const

export const flexGapValues = ['small', 'middle', 'large'] as const
